<template>
  <div class="bg-slate-50 lg:p-8">
    <div class="max-w-4xl mx-auto">
      <!-- Tabs Container -->
      <div class="w-full">
        <div class="rounded-lg mb-6">
          <div class="grid grid-cols-4 gap-1 bg-transparent h-auto">
            <button
              v-for="tab in tabs"
              :key="tab.key"
              @click="select(tab.key)"
              class="flex items-center justify-center py-2 px-3 rounded-md font-medium transition-all text-sm border-0"
              :class="current === tab.key 
                ? 'bg-white text-blue-600'
                : 'text-slate-800 hover:text-slate-900'"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">
          <div v-show="current === 'offers'" class="space-y-6">
            <OffersModule ref="offersRef" @archived="refreshBoth" />
          </div>
          <div v-show="current === 'archive'" class="space-y-6">
            <OffersModule archived ref="archivedRef" />
          </div>
          <div v-show="current === 'settings'" class="space-y-6">
            <div class="bg-white rounded-lg border border-slate-200 p-4">
              <h3 class="text-base font-semibold text-slate-800 mb-4">Adres używany w Marketplace</h3>
              <SettingsAddress />
            </div>
          </div>
          <div v-show="current === 'chat'" class="space-y-6">
            <div class="bg-white rounded-lg border border-slate-200 p-4">
              <ChatPanel />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import OffersModule from '../modules/offers/OffersModule.vue';
import ChatPanel from './ChatPanel.vue';
import SettingsAddress from './SettingsAddress.vue';

const tabs = [
  { key: 'offers', label: 'Ogłoszenia' },
  { key: 'archive', label: 'Archiwum' },
  { key: 'settings', label: 'Ustawienia' },
  { key: 'chat', label: 'Czat' },
] as const;

type TabKey = typeof tabs[number]['key'];
const current = ref<TabKey>('offers');
const offersRef = ref<InstanceType<typeof OffersModule> | null>(null);
const archivedRef = ref<InstanceType<typeof OffersModule> | null>(null);

function select(key: TabKey) {
  current.value = key;
}

function refreshBoth() {
  offersRef.value?.refresh?.();
  archivedRef.value?.refresh?.();
}

onMounted(() => {
  try {
    const params = new URLSearchParams(window.location.search);
    const offerId = params.get('offerId');
    if (offerId) {
      current.value = 'chat';
    }
  } catch {}
});
</script>

<style scoped>
.nav-tabs .nav-link {
  cursor: pointer;
}
</style>
